import React from 'react';
import { EmailSignalEngine } from '../../utils/emailSignalData';

export default function EmailSignalGate({ currentRole, children }) {
  const isEnabled = EmailSignalEngine.isFeatureEnabled(currentRole);

  if (!isEnabled) {
    return (
      <div className="dashboard-container">
        <div className="bg-nn-white rounded-[14px] shadow-card overflow-hidden hover:shadow-md transition-shadow relative" style={{ padding: 40, textAlign: 'center' }}>
          <h2 className="text-2xl" style={{ fontWeight: 300, marginBottom: 16 }}>Email Signal Engine</h2>
          <p className="text-text-muted" style={{ marginBottom: 20 }}>
            This feature is not enabled for your role. Contact your administrator to enable it.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
